import moment from 'moment'

export const HANDOVER_DATE_FORMAT = 'DD.MM.YYYY HH:mm'

export const formatProtocolDate = (value: string | null | undefined): string => (value ? moment(value).format(HANDOVER_DATE_FORMAT) : '-')

export interface IEmailStatus {
	label: string
	color: string
	canResend: boolean
}

export const getEmailStatus = (row: { emailSentAt: string | null }): IEmailStatus => (
	row.emailSentAt
		? { label: 'Odoslané', color: 'green', canResend: false }
		: { label: 'Neodoslané', color: 'orange', canResend: true }
)

/**
 * Storno je destruktivna akcia na pravne vyznamnom doklade - riadi sa tym istym granularnym
 * mazacim pravom ako ostatne entity (SUPERADMIN prejde vzdy, ostatni potrebuju explicitny flag).
 */
export const canVoidProtocol = (profile: { role?: string, hasPermissionToRemoveHandoverProtocol?: boolean } | null | undefined): boolean => {
	if (!profile) return false
	if (String(profile.role) === 'SUPERADMIN') return true
	return !!profile.hasPermissionToRemoveHandoverProtocol
}
